import React, { useState } from 'react';
import classes from './changePassword.module.css';
import InputField from '../../containers/inputField/inputField';
import PromptMessage from '../../containers/promptMessage/promptMessage';
import { sixYardAxios } from '../../../sixYardAxios';
import qs from 'qs';
import Loader from '../../hoc/layout/loader/loader';

const ChangePassword = (props) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [controls, setControls] = useState({
    currentPassword: {
      elementType: "input",
      elementConfig: {
        type: "password",
        placeholder: "Enter current password",
      },
      value: "",
      validation: {
        required: true,
      },
      label: "Current Password",
      valid: false,
      touched: false
    },
    newPassword: {
      elementType: "input",
      elementConfig: {
        type: "password",
        placeholder: "Enter new password",
      },
      value: "",
      validation: {
        required: true,
      },
      label: "New Password",
      valid: false,
      touched: false
    },
    newPasswordConfirmation: {
      elementType: "input",
      elementConfig: {
        type: "password",
        placeholder: "Confirm new password",
      },
      value: "",
      validation: {
        required: true,
      },
      label: "Confirm New Password",
      valid: false,
      touched: false
    }
  });
  const formElementsArray = [];
  for (let key in controls) {
    formElementsArray.push({
      id: key,
      config: controls[key]
    });
  }
  const form = formElementsArray.map((formElement, i) => (
    <div key={i} className={classes.FormGroup}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        withRemove={false}
        label={formElement.config.label}
        changed={event => inputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  const inputChangedHandler = (event, controlName) => {
    const updatedControls = {
      ...controls,
      [controlName]: {
        ...controls[controlName],
        value: event.target.value,
        touched: true
      }
    };
    setControls(updatedControls);
  };

  const submitHandler = e => {
    e.preventDefault();
  };
  const updatePasswordHandler = () => {
    setLoading(true);
    const { newPassword, newPasswordConfirmation, currentPassword } = controls;
    // if (newPassword.value !== newPasswordConfirmation.value) {
    //   setError("New password and confirmation do not match.")
    //   return;
    // }
    // if (newPassword.value.length === 0 || newPasswordConfirmation.value.length === 0 || currentPassword.value.length === 0) {
    //   setError("Please fill all required field")
    //   return;
    // }
    setError(false);
    sixYardAxios
    .post("/profile/change-password",
      qs.stringify({
        current_password: currentPassword.value,
        new_password: newPassword.value,
        new_password_confirmation: newPasswordConfirmation.value
      }))
      .then(res => {
        setSuccessMessage(res.data.message);
        clearControls();

      })
      .catch(err => {
        setError(err.response.data.message)
      }).finally(() => {
        setLoading(false);  
      })  
  }
  const cancelChangePassword = () => {
    clearControls();
  }
  const clearControls = () => {
    const updatedControls = {
      ...controls
    };
    for (let key in controls) {
      updatedControls[key] = {
        ...controls[key],
        value: "",
        valid: false,
        touched: false
      };
    }
    setControls(updatedControls);
  };
  return (
    loading ? <Loader/> :
    <div className={classes.FormLayout}>
      <form className={classes.Form} onSubmit={(e) => submitHandler(e)}>
        {form}
        <div className={classes.Buttons}>
          <button onClick={cancelChangePassword}>CANCEL</button>
          <button type="submit" onClick={updatePasswordHandler}>SAVE</button>
        </div>
      </form>
      {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
      {successMessage && <PromptMessage message={successMessage} status='CONGRATULATIONS' successMessage
        button='CLOSE' click={() => setSuccessMessage(false)} />}
    </div>
  )
}

export default ChangePassword;